import { LandingComponent } from "../components/Landing";
import Layout from "../components/Layout";
import Protected from "../components/Protected";
import { OneColumnContainer } from "../components/ColumnContainers/OneColumnContainer";

export default function Landing() {
  return (
    <Layout title="GolfChamps | Home">
      <Protected>
        <OneColumnContainer>
          <LandingComponent />
        </OneColumnContainer>
      </Protected>
    </Layout>
  );
}
